import styled from "styled-components";

export const PlaceholderPage = styled.main`
  min-height: 80dvh;
  display: grid;
  place-items: center;
  box-sizing: border-box;
  padding: 120px ${({ theme }) => theme.padding.regular}
    ${({ theme }) => theme.padding.regular};

  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.spacing.regular}
      ${({ theme }) => theme.padding.small};
  }
`;

export const PlaceholderCard = styled.article`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.regular};
  width: min(100%, 720px);
  box-sizing: border-box;
  padding: ${({ theme }) => theme.padding.large};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background: ${({ theme }) => theme.colors.lightBlue};
  color: ${({ theme }) => theme.colors.darkBlue};

  span {
    font-size: ${({ theme }) => theme.typography.regular.fontSize};
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
    text-transform: uppercase;
  }

  h1,
  p {
    margin: 0;
  }

  h1 {
    font-size: ${({ theme }) => theme.typography.h1.fontSize};
    text-transform: uppercase;

    @media (max-width: 520px) {
      font-size: 2.5rem;
    }
    @media (min-width: 2500px) {
      font-size: 4rem;
    }

    @media (min-width: 3400px) {
      font-size: 5.25rem;
    }
    @media (min-width: 3800px) {
      font-size: 5.75rem;
    }
    @media (min-width: 4500px) {
      font-size: 6.25rem;
    }
    @media (min-width: 5000px) {
      font-size: 6.75rem;
    }
  }

  p {
    @media (max-width: 520px) {
      font-size: ${({ theme }) => theme.typography.medium.fontSize};
    }
    @media (min-width: 2500px) {
      font-size: 1.75rem;
    }
    @media (min-width: 3000px) {
      font-size: 2rem;
    }
    @media (min-width: 3400px) {
      font-size: 2.5rem;
    }
    @media (min-width: 3800px) {
      font-size: 3rem;
    }
    @media (min-width: 4500px) {
      font-size: 3.25rem;
    }
    @media (min-width: 5000px) {
      font-size: 3.75rem;
    }
  }

  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.regular};
  }

  @media (min-width: 2500px) {
    // width: min(100%, 40dvw);
    width: min(900px, 40dvw);
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
  @media (min-width: 3000px) {
    gap: 24px;
    padding: 52px;
  }
  @media (min-width: 3800px) {
    gap: ${({ theme }) => theme.spacing.medium};
    border-radius: ${({ theme }) => theme.borderRadius.xlarge};
    width: min(35dvw, 40dvw);
  }
  @media (min-width: 4500px) {
    gap: 52px;
    padding: 82px;
  }
`;

export const BackLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.small};
  width: fit-content;
  padding: 12px 18px;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.greyBlue};
  color: ${({ theme }) => theme.colors.offWhite};
  font-size: ${({ theme }) => theme.typography.medium.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.25s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.accent};
  }

  @media (min-width: 2500px) {
    font-size: 1.5rem;
    padding: 18px 28px;
  }
  @media (min-width: 3000px) {
    font-size: 1.75rem;
    padding: 20px 30px;
    gap: ${({ theme }) => theme.spacing.regular};
  }
  @media (min-width: 3400px) {
    font-size: 2.25rem;
    padding: 24px 32px;
  }
  @media (min-width: 3800px) {
    font-size: 2.575rem;
    padding: 28px 36px;
  }
  @media (min-width: 4500px) {
    font-size: 3rem;
    padding: 32px 50px;
  }
  @media (min-width: 5000px) {
    font-size: 3.5rem;
    padding: 36px 54px;
  }
`;
